// Utility functions for clearing all storage
// Used when redirecting to login to ensure no data persists

import { tokenStorage } from './tokenStorage';

/**
 * Clears all storage including tokens, localStorage, and sessionStorage
 * This ensures a complete clean state when redirecting to login
 * No tokens or data should persist when user visits root or login routes
 */
export const clearAllStorage = (): void => {
  // Clear all tokens first
  tokenStorage.clearAllTokens();

  // Clear ALL localStorage
  try {
    localStorage.clear();
  } catch {
    // If clear() fails, manually remove known items
    localStorage.removeItem('user');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('currentprojectselected');
    localStorage.removeItem('chatbot-tooltip-shown');
    localStorage.removeItem('auth_error');
    localStorage.removeItem('theme');
    // Clear any Zustand persisted state keys
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith('zustand-') || key.includes('store')) {
        localStorage.removeItem(key);
      }
    });
  }

  // Clear ALL sessionStorage
  try {
    sessionStorage.clear();
  } catch {
    // If clear() fails, manually remove known items
    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      sessionStorage.removeItem(key);
    });
  }
};
